<template>
  <div class="excellent-capabilities-server-list">
    <common-bg-plate>
      <div class="add-server-config">
        <btn-style :btn-list="btnList"></btn-style>
        <div class="add-server-config-hint">若已部署，请在此添加服务器配置进行调用测试</div>
      </div>
      <normal-table
        ref="commonTable"
        :table-col="tableCol"
        :table-data="serverList"
        :operator="operator"
        :operate-col="operateCol"
        :paging="serverPaging"
        :show-edit="true"
        @pagination="handleSizeOrPageChange"
      >
        <template slot="serverPorts" slot-scope="{ param }">
          <div class="server-ports">
            <div v-for="(item, index) in JSON.parse(param.row.encryptsvrs)" :key="index">
              <span>{{ item.serverID | transPort($constants.EMPTY) }}</span
              ><span>{{ `(${item.serverport})` }}</span>
            </div>
          </div>
        </template>
      </normal-table>
      <add-server-config ref="addServerDialog" @getList="getList"></add-server-config>
    </common-bg-plate>
  </div>
</template>

<script>
import addServerConfig from './addServerConfig'
import { mapState, mapActions } from 'vuex'
export default {
  name: 'ServerList',
  components: {
    addServerConfig
  },
  filters: {
    transPort: function(value, defaultVal) {
      if (value == 1) {
        return '多方安全计算'
      } else if (value == 2) {
        return '密文检索'
      } else if (value == 3) {
        return '属性加密'
      } else {
        return defaultVal
      }
    }
  },
  data() {
    return {
      btnList: [
        {
          btnContent: '添加服务器配置',
          click: () => {
            return this.addServerConfig()
          },
          icon: 'icon-gen'
        }
      ],
      // 设置table的列
      tableCol: [
        {
          prop: 'ip',
          label: '服务器IP',
          minWidth: 242
        },
        {
          prop: 'servername',
          label: '服务器名称',
          minWidth: 230
        },
        {
          prop: 'serverport',
          label: '服务端口',
          minWidth: 247,
          slotName: 'serverPorts'
        },
        {
          prop: 'createAt',
          label: '创建时间',
          formatter: row => {
            return this.formatTime(row)
          },
          minWidth: 235
        }
      ],
      // table的基本操作
      operator: [
        {
          text: '调用测试',
          click: (row, col, cellValue) => {
            return this.callTest(row)
          },
          showText: true,
          icon: 'icon-check'
        },
        {
          text: '编辑',
          showText: true,
          click: (row, col, cellValue) => {
            return this.editServer(row)
          },
          icon: 'icon-apply'
        },
        {
          showText: true,
          text: '删除',
          click: (row, col, cellValue) => {
            return this.delServer(row)
          },
          icon: 'icon-cancel'
        }
      ],
      operateCol: {
        minWidth: 213
      }
    }
  },
  computed: {
    ...mapState({
      serverList: state => state.excellent.server_list,
      serverPaging: state => state.excellent.server_paging
    })
  },
  mounted() {
    this.getList()
  },
  methods: {
    ...mapActions(['encryptConfigList']),
    getList(limit = 10, offset = 0, name) {
      const userInfoStr = localStorage.getItem('cbaas_system_userInfo')
      const userInfo = userInfoStr ? JSON.parse(userInfoStr) : {}
      let formObj = {}
      formObj.userid = '1'
      formObj.limit = limit
      formObj.offset = offset
      this.encryptConfigList(formObj)
    },
    handleSizeOrPageChange(data) {
      const { offset, limit } = data
      this.getList(limit, offset * limit)
    },
    delServer(row) {
      this.$confirm('此操作将删除已部署服务配置, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          let formObj = {}
          formObj.ip = row.ip
          this.$apis.excellent.encryptConfigDel(formObj).then(res => {
            if (res) {
              this.$message.success('删除成功')
              this.getList()
            }
          })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
    },
    editServer(row) {
      ;(row.title = '修改服务器配置'), (row.domains = JSON.parse(row.encryptsvrs))
      this.$refs.addServerDialog.handleOpen(row)
    },
    formatTime(row) {
      return this.$utils.dateFormat('YYYY-mm-dd HH:MM', row.createAt)
    },
    addServerConfig() {
      let data = {
        title: '添加服务器配置'
      }
      this.$refs.addServerDialog.handleOpen(data)
    },
    callTest(row) {
      this.$router.push({
        name: 'callTest',
        query: {
          row: JSON.stringify(row)
        }
      })
    }
  }
}
</script>

<style scoped lang="scss">
@import '@/styles/variables/theme';
@import '@/styles/variables/adaptation';
@include theme(
  'excellent-capabilities-server-list',
  (
    --excellent-capabilities-server-list-add-server-config-hint-color: #ffffff,
    --excellent-capabilities-server-list-operate-color: #45c2ff
  ),
  (
    --excellent-capabilities-server-list-add-server-config-hint-color: #192227,
    --excellent-capabilities-server-list-operate-color: #45c2ff
  )
);
.excellent-capabilities-server-list {
  @include adaptation(
    (
      --excellent-capabilities-server-list-unavailable-height: 819px,
      --excellent-capabilities-server-list-empty-padding: 20px 0 40px,
      --excellent-capabilities-server-list-padding: 16px 16px 0 16px,
      --excellent-capabilities-server-list-padding-top: 16px,
      --excellent-capabilities-server-list-add-server-config-height: 32px,
      --excellent-capabilities-server-list-add-server-config-margin-bottom: 16px,
      --excellent-capabilities-server-list-add-server-config-hint-margin-left: 12px
    )
  );
  --excellent-capabilities-server-list-min-height: calc(
    var(--base-main-router-body-avaliable-height) - var(--excellent-capabilities-server-list-unavailable-height)
  );
  --excellent-capabilities-server-list-table-min-height: calc(
    var(--base-main-router-body-avaliable-height) - var(--excellent-capabilities-server-list-unavailable-height) -
      var(--excellent-capabilities-server-list-padding-top) -
      var(--excellent-capabilities-server-list-add-server-config-height) -
      var(--excellent-capabilities-server-list-add-server-config-margin-bottom)
  );
  .common-bg-plate {
    padding: var(--excellent-capabilities-server-list-padding);
    min-height: var(--excellent-capabilities-server-list-min-height);

    .add-server-config {
      display: flex;
      align-items: center;
      margin-bottom: var(--excellent-capabilities-server-list-add-server-config-margin-bottom);

      .add-server-config-hint {
        color: var(--excellent-capabilities-server-list-add-server-config-hint-color);
        margin-left: var(--excellent-capabilities-server-list-add-server-config-hint-margin-left);
      }
    }

    .normal-table-wrap {
      height: 100%;
      min-height: var(--excellent-capabilities-server-list-table-min-height);

      /deep/ {
        .el-empty {
          height: 100%;
          min-height: var(--excellent-capabilities-server-list-table-min-height);
          padding: var(--excellent-capabilities-server-list-empty-padding);
        }

        .normal-table {
          height: 100%;
          min-height: var(--excellent-capabilities-server-list-table-min-height);

          .operate-item {
            color: var(--excellent-capabilities-server-list-operate-color);
          }
        }
      }
    }
  }
}
</style>
